// extracted by mini-css-extract-plugin
module.exports = {"ulist":"StrapiRichText_ulist__7tbU5","olist":"StrapiRichText_olist__z3a_d"};